import { useState } from 'react'

const useEmailValidation = () => {
    const [isEmailValid, setValid] = useState(true)

    const validateEmail = (event: React.FormEvent<HTMLInputElement>) => {
        const input = event.currentTarget.value
        const emailRegex = /^[^\s@]+@[^\s@]+$/
        if (emailRegex.test(input)) {
            setValid(true)
        } else {
            setValid(false)
        }
    } 

    return {
        isEmailValid,
        validateEmail
    }
}

export default useEmailValidation
